import React, { Fragment, useEffect, useRef, useCallback } from "react";
import { useMutationObserver } from "hooks/useMutationsObserver";
import { FONT_SIZE_CHANGED } from "../constants";
import { useDispatch, useSelector } from "react-redux";

const Navbar = ({
                    navToken,
                    messageId,
                    loginUrl,
                    logoutUrl,
                    hideEntitySearch,
                    hidePersons,
                    hideEntities,
                    hideVisionImpaired,
                    hideDyslexia,
                    hideFontResize,
                    hideLoginButton,
                    isAuthenticated,
                    logout,
                    test,
                    changeEntityUrl,
                    forPersonOib,
                    forLegalIps,
                    forLegalIzvor,
                    toLegalIps,
                    toLegalIzvor,
                    handleFontResize,
                    handleVisionImpaired,
                    handleDyslexia,
                    handleBtnPotvrdite,
                }) => {
    const navRef = useRef();
    const scriptRef = useRef();
    const dispatch = useDispatch();
    const isImpaired = useSelector((state) => state.layout.isImpaired);
    const isDyslexic = useSelector((state) => state.layout.isDyslexic);

    let navbarTestUrl = "https://eusluge-nav-test.gov.hr/e_gradani.aspx";
    let navbarProdUrl = "https://eusluge-nav.gov.hr/e_gradani.aspx";

    const mountScript = (src) => {
        const script = document.createElement("script");
        script.src = src;
        script.id = "navbar";
        script.async = true;
        script.ref = scriptRef;
        document.body.appendChild(script);
    };

    const loadScript = (url) => {
        const script = document.getElementById("navbar");
        if (script) {
            script.parentNode.removeChild(script);
        }
        mountScript(url);
    };

    const buildUrl = () => {
        let url = `${test ? navbarTestUrl : navbarProdUrl}?`;
        if (messageId) {
            url += `&messageId=${messageId}`;
        }
        if (!messageId) {
            url += `&messageId=false`;
        }
        if (navToken) {
            url += `&navToken=${navToken}`;
        }
        if (loginUrl) {
            url += `&login_url=${loginUrl}`;
        }
        if (logoutUrl) {
            url += `&logout_url=${logoutUrl}`;
        }
        if (hideEntitySearch) {
            url += `&show_entity_search=true`;
        }
        if (hidePersons) {
            url += "&show_persons=false";
        }
        if (hideEntities) {
            url += "&show_entities=false";
        }
        if (hideVisionImpaired) {
            url += "&show_vision_impaired=false";
        }
        if (hideDyslexia) {
            url += "&show_dyslexia=false";
        }
        if (hideFontResize) {
            url += "&show_font_resize=false";
        }
        if (hideLoginButton) {
            url += "&show_login_button=false";
        }
        if (changeEntityUrl) {
            url += `&change_entity_url=${changeEntityUrl}`;
        }
        if (forPersonOib) {
            url += `&ForPersonOib=${forPersonOib}`;
        }
        if (forLegalIps) {
            url += `&ForLegalIps=${forLegalIps}`;
        }
        if (forLegalIzvor) {
            url += `&ForLegalIzvor_reg=${forLegalIzvor}`;
        }
        if (toLegalIps) {
            url += `&ToLegalIps=${toLegalIps}`;
        }
        if (toLegalIzvor) {
            url += `&ToLegalIzvor_reg=${toLegalIzvor}`;
        }

        loadScript(url.replace("&", ""));
    };

    useEffect(() => {
        buildUrl();
    }, [
        messageId,
        navToken,
        loginUrl,
        logoutUrl,
        hidePersons,
        hideEntities,
        hideVisionImpaired,
        hideDyslexia,
        hideFontResize,
        hideLoginButton,
        test,
        changeEntityUrl,
        forPersonOib,
        forLegalIps,
        forLegalIzvor,
        toLegalIps,
        toLegalIzvor,
    ]);

    // Funkcija za rukovanje promjenama
    const handleMutations = useCallback(
        (mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.target.id === "filter_holder") {
                    const allowedValues = [
                        "80",
                        "85",
                        "90",
                        "95",
                        "100",
                        "105",
                        "110",
                        "115",
                        "120",
                    ];
                    if (
                        allowedValues.includes(
                            mutation.target.style.cssText.replace(/\D/g, "")
                        )
                    ) {
                        dispatch({
                            type: FONT_SIZE_CHANGED,
                            payload: mutation.target.style.cssText.replace(/\D/g, ""),
                        });
                    }
                }
                // Provjera slabovidnosti
                if (mutation.target.id === "impaired") {
                    const isDisplayed = mutation.target.style.display?.includes("flex");
                    handleVisionImpaired(isDisplayed);
                }
                // Provjera disleksije
                if (mutation.target.id === "dyslexic") {
                    const isDyslexic = mutation.target.style.display?.includes("flex");
                    handleDyslexia(isDyslexic);
                }

                if (mutation.target.className === "zgl-button log_out") {
                    if (mutation.target.style.display === "none" && isAuthenticated) {
                        logout();
                    }
                }
            });
        },
        [dispatch, handleVisionImpaired, handleDyslexia, isAuthenticated, logout]
    );


    // Praćenje elemenata za vision-impaired mod
    useEffect(() => {
        const observer = new MutationObserver(() => {
            // Prilagodba slabovidnosti
            const impairedElement = document.getElementById("impaired");
            const nonImpairedElement = document.getElementById("nonimpaired");
            // Ako su elementi pronađeni, postavi stilove
            if (impairedElement && nonImpairedElement) {
                impairedElement.style.display = isImpaired ? "flex" : "none";
                nonImpairedElement.style.display = !isImpaired ? "flex" : "none";
            }
            // Disleksija
            const dyslexicElement = document.getElementById("dyslexic");
            const nondyslexicElement = document.getElementById("nondyslexic");
            // Ako su elementi pronađeni, postavi stilove
            if (dyslexicElement && nondyslexicElement) {
                dyslexicElement.style.display = isDyslexic ? "flex" : "none";
                nondyslexicElement.style.display = !isDyslexic ? "flex" : "none";
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, [isImpaired, isDyslexic]);

    // Rukovanje klikom na btnPotvrdite unutar odgovarajućeg useEffect-a
    useEffect(() => {
        const btnPotvrdite = document.getElementById("btnPotvrdite");
        const handleClick = () => handleBtnPotvrdite();

        if (btnPotvrdite) {
            btnPotvrdite.addEventListener("click", handleClick);
        }

        return () => btnPotvrdite?.removeEventListener("click", handleClick);
    }, [handleBtnPotvrdite]);

    // Korištenje prilagođenog hooka za MutationObserver
    useMutationObserver({
        target: navRef,
        options: {
            childList: true,
            subtree: true,
            attributes: true,
            attributeOldValue: true,
        },
        callback: handleMutations,
    });

    return (
        <Fragment>
            <div ref={navRef}>
                <div className="egradani_traka-holder"></div>
            </div>
        </Fragment>
    );
};

export default Navbar;